__turbopack_context__.v({
  "testimonial-author": "testimonial-card-module-scss-module__lfr5gW__testimonial-author",
  "testimonial-body": "testimonial-card-module-scss-module__lfr5gW__testimonial-body",
  "testimonial-card": "testimonial-card-module-scss-module__lfr5gW__testimonial-card",
  "testimonial-content": "testimonial-card-module-scss-module__lfr5gW__testimonial-content",
  "testimonial-icon": "testimonial-card-module-scss-module__lfr5gW__testimonial-icon",
  "testimonial-quote": "testimonial-card-module-scss-module__lfr5gW__testimonial-quote",
  "testimonial-text-container": "testimonial-card-module-scss-module__lfr5gW__testimonial-text-container",
});
